/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */

import { FileType } from "../Api/Api";
import React from "react";
import { FaQuestionCircle } from "react-icons/fa";
import { useDexterTheme } from "../DesignSystem/Theme/ThemeContext";
import { ThemeNames } from "../DesignSystem/Theme/Theme";

const PROTO_LOGO_URL = new URL(
  "../resources/images/protobuf_logo.png",
  import.meta.url
);

const XML_LOGO_URL = new URL(
  "../resources/images/xml_logo.svg",
  import.meta.url
);

const XML_LOGO_DARK_URL = new URL(
  "../resources/images/xml_logo_dark.svg",
  import.meta.url
);

const NodeLogo = ({
  fileTypeFromDescriptor,
}: {
  fileTypeFromDescriptor: FileType;
}): JSX.Element => {
  const { currentTheme, currentThemeName } = useDexterTheme();

  // We should return a question mark in the event the file type
  // is not known.
  if (fileTypeFromDescriptor === FileType.UNDETECTED) {
    return (
      <FaQuestionCircle
        size={18}
        style={{
          color: currentTheme.colors.secondary,
          verticalAlign: "middle",
        }}
        title="Unknown file type"
      />
    );
  }

  const isCurrentThemeDark =
    currentThemeName == ThemeNames.DARK ||
    currentThemeName == ThemeNames.COLORBLIND_DARK;

  const logoUrl = getNodeTypeLogo(fileTypeFromDescriptor, isCurrentThemeDark);
  return (
    fileTypeFromDescriptor != undefined &&
    logoUrl != "" && (
      <img
        src={logoUrl}
        style={{
          width: fileTypeFromDescriptor == FileType.XML ? "30px" : "20px",
          height: fileTypeFromDescriptor == FileType.XML ? "30px" : "20px",
          marginRight: "3px",
        }}
      />
    )
  );
};

function getNodeTypeLogo(
  fileType: FileType,
  isCurrentThemeDark: boolean
): string {
  switch (fileType) {
    case FileType.PROTO:
      return PROTO_LOGO_URL.toString();
    case FileType.XML:
      if (isCurrentThemeDark) return XML_LOGO_DARK_URL.toString();
      else return XML_LOGO_URL.toString();
    default:
      return "";
  }
}

export default NodeLogo;
